import Form from './Form';
import {getUrlVar, waitForTrans} from './utils';

// TODO: refactor jQuery --> ES
let customboneSelf; // FIXME
export default class Custombone {
    constructor(app) {
        this.app = app;
        customboneSelf = this;

        customboneSelf.var_valid = true;
        customboneSelf.handledrequiredOnce = [];

        // radio
        $("input[name$='_visual'][type=radio]").change(function (e) {
            if ($(this).data("true_val")) {
                $("input#" + $(this).attr("name").replace("_visual", "")).val($(this).data("true_val"));
            }
        });
        // checkbox
        $("input[name$='_visual'][type=checkbox]").change(function (e) {
            if ($(this).data("true_val")) {
                // find other checkboxes
                let options = $(this).parent().parent().children(".choice-btn").children("input[name$='_visual'][type=checkbox]:checked").first()

                $("input#" + $(this).attr("name").replace("_visual", ""))
                    .val($(this).is(":checked") ? $(this).data("true_val") : (options ? options.data("true_val") : ""));
            }
        });
/*
        let $aufmassform = $("#aufmassform");
        $aufmassform.find('input[type="submit"]').on("click", function (event) {
            $(".js-sf-error").removeClass("is-active");
            customboneSelf.var_valid = true;
            event.preventDefault();
            customboneSelf.handledrequiredOnce = [];

            $aufmassform.find("input:not(:disabled),select:not(:disabled)").each(function (i, v) {
                if ($(this).hasClass("requiredbone") || $(this).hasClass("is-required")) {
                    customboneSelf._checkrequired($(this));
                }
                if ($(this).hasClass("requiredOnce")) {
                    customboneSelf._checkrequiredOnce($(this));
                }
            });

            if (customboneSelf.var_valid) {
                $aufmassform.submit();
            } else {
                $('html,body').animate({
                        scrollTop: $("body").offset().top - 100
                    }, 1000
                );
                $(".js-sf-error").addClass("is-active");
            }
        });

        customboneSelf.toggleForms($("#aufmassbtn"), "js-aufmassBlock");
        customboneSelf.toggleForms($("#montage"), "js-montageBlock");

        $("#aufmassbtn").on("click", function () {
            customboneSelf.toggleForms($(this), "js-aufmassBlock");
        });
        $("#montage").on("click", function () {
            customboneSelf.toggleForms($(this), "js-montageBlock");
        }); */

        $(".js-toogle-form-tab").on("change", function () {
            if ($(this).is(":checked")) {
                $($(this).data("toogle-section"))
                    .addClass('is-active')
                    .find("input").removeAttr("disabled");
            } else {
                $($(this).data("toogle-section"))
                    .removeClass('is-active')
                    .find("input").attr("disabled", "disabled");
            }
        });

        /**
         * Duplicate inputs and enforce equal values
         */
        waitForTrans(() => {
            $('.js-input-duplicate').each(function () {
                let $firstInput = $(this).addClass('js-input');
                let $firstGroup = $firstInput.closest('.js-input-group');
                // let $firstLabel = $firstGroup.find('.js-label');

                let $secondGroup = $firstGroup.clone();
                let $secondInput = $secondGroup.find('.js-input');
                let $secondLabel = $secondGroup.find('.js-label');

                function compareEquality() {
                    const secondHtmlElement = $secondInput.get(0);
                    secondHtmlElement.setCustomValidity('');

                    if ($firstInput.val() !== $secondInput.val()) {
                        secondHtmlElement.setCustomValidity(customboneSelf.app.info.translations['formmailing.repeat.input.unequal'])
                    }
                }

                $firstInput
                    .addClass('js-first-input')
                    .on('input', compareEquality);

                $secondLabel.text(customboneSelf.app.info.translations[$secondInput.attr('name') + '_clone']);

                $secondInput
                    .addClass('js-second-input')
                    .attr('id', $secondInput.attr('id') + '_clone')
                    .attr('name', $secondInput.attr('name') + '_clone')
                    .on('input', compareEquality);

                $secondGroup.find('.js-hint').remove();

                $secondGroup.insertAfter($firstGroup);
            })
        });

        let preselect = window.location.hash.toLowerCase();
        if (preselect === "#gomontage") {
            $("#montage").trigger('click');
        } else if (preselect === "#goaufmass") {
            $("#aufmassbtn").trigger('click');
        }

        const serviceForm = document.querySelector('#aufmassform');
        if (serviceForm !== null) {
            Form.addressAutocomplete({
                form: serviceForm,
                options: {
                    componentRestrictions: {
                        country: ['de', 'at'],
                    }
                }
            });
        }

        /**
         * Set viewing mode by checking the header
         */
		/*
        if (getUrlVar('goSchulte')) { // schulte mode
            $('.js-dk-info').hide().find('.requiredOnce').removeClass('requiredOnce');
            $('.js-marketCheckBox').hide();
            $('.header, .breadcrumbs').hide();

            $.getJSON('/json/constructionmarket/list/?customer_number=100041').done(data => {
                if (data && data['skellist'].length) {
                    $('#rel-dest-markt').val(data['skellist'][0]['key']);
                    $('#ignt-id-markt_name').val(data['skellist'][0]['name']);
                }
            });
            $('.js-answtime').toggleClass("is-hidden");
        } else { // normale mode
            $('.js-schulte-mode').hide().find('.requiredOnce').removeClass('requiredOnce');
        }*/
    }

    _checkrequired($input) {
        if (
            ($input.attr("type") != "checkbox" && (!$input.val() || $input.val() == "False")) ||
            ($input.attr("type") == "checkbox" && !$input.is(":checked"))
        ) {
            customboneSelf._markError($input);
            customboneSelf.var_valid = false;
        } else {
            customboneSelf._unmarkError($input);
        }
    }

    _checkrequiredOnce($input) {
        // Function to check, if at least one item is selected.
        // Works only for radio and checkboxes!!
        // console.log("check requiredOnce", $input);
        let found = false;

        // check if inputfield is already in handlelist
        if (-1 == customboneSelf.handledrequiredOnce.indexOf($input.attr("name"))) {
            // it is not, add field to list
            customboneSelf.handledrequiredOnce.push($input.attr("name"));
            $("input[name=" + $input.attr("name").replace("_visual", "") + "]").each(function (i, val) {
                if (($(this).attr("type") != "checkbox" && $(this).attr("type") != "radio" && !!$(this).val() && $(this).val() != "False")
                    || ($(this).attr("type") == "radio" && $(this).is(":checked"))
                    || ($(this).attr("type") == "checkbox" && $(this).is(":checked"))
                ) {
                    found = true;
                    return false;
                }
            });

            if (!found) {
                $("input[name^=" + $input.attr("name").replace("_visual", "") + "]").each(function (i, val) {
                    customboneSelf._markError($(this));
                });
                customboneSelf.var_valid = false;
            } else {
                $("input[name^=" + $input.attr("name").replace("_visual", "") + "]").each(function (i, val) {
                    customboneSelf._unmarkError($(this));
                });
            }
        }
    }

    _unmarkError($input) {
        // console.debug("unmark error", $input);

        if ($input.hasClass("js_error")) {
            $input.removeClass("js_error");
        }
        let $parentDiv = $input.closest("div");
        if ($input.attr("type") == "checkbox" || $input.attr("type") == "radio") {
            $parentDiv.parent().find(".js-errorlabel").removeClass("is-invalid");
        } else {
            $input.removeClass("is-invalid")
        }
    }


    _markError($input) {
        // console.debug("mark error", $input);

        if (!$input.hasClass("js_error")) {
            $input.addClass("js_error")
        }
        let $parentDiv = $input.closest("div");
        if ($input.attr("type") == "checkbox" || $input.attr("type") == "radio") {
            $parentDiv.parent().find(".js-errorlabel").addClass("is-invalid");
        } else {
            $input.addClass("is-invalid")
        }
    }

    toggleForms(obj, mode) {
        let astat = $("#aufmassbtn").is(":checked");
        let mstat = $("#montage").is(":checked");

        if (astat && mstat) {
            $(".js-montageBlock").addClass('is-active');
            $(".js-aufmassBlock").addClass('is-active');
            $(".js-service-submit").removeAttr("disabled");

            $(".js-aufmassBlock,.js-montageBlock").find("input,select").each(function (i, v) {
                $(this).removeAttr("disabled");
            })
        } else if (astat && !mstat) {
            $(".js-montageBlock").removeClass('is-active');
            $(".js-aufmassBlock").addClass('is-active');
            $(".js-service-submit").removeAttr("disabled");

            $(".js-aufmassBlock").find("input,select").each(function (i, v) {
                $(this).removeAttr("disabled");
            });
            $(".js-montageBlock").not(".js-aufmassBlock").find("input,select").each(function (i, v) {
                $(this).attr("disabled", "disabled");
            })
        } else if (!astat && mstat) {
            $(".js-aufmassBlock").removeClass('is-active');
            $(".js-montageBlock").addClass('is-active');
            $(".js-service-submit").removeAttr("disabled");

            $(".js-montageBlock").find("input,select").each(function (i, v) {
                $(this).removeAttr("disabled");
            })
            $(".js-aufmassBlock").not(".js-montageBlock").find("input,select").each(function (i, v) {
                $(this).attr("disabled", "disabled");
            })

        } else if (!astat && !mstat) {
            $(".js-aufmassBlock").removeClass('is-active');
            $(".js-montageBlock").removeClass('is-active');
            $(".js-service-submit").attr("disabled", "disabled");
            $(".js-aufmassBlock,.js-montageBlock").find("input,select").each(function (i, v) {
                $(this).attr("disabled", "disabled")
            })
        }

        if (astat || mstat) {
            $(".js-abbauservice").show();
        } else {
            $(".js-abbauservice").hide();
        }
    }
}


